import { render, staticRenderFns } from "./YearCalendar.vue?vue&type=template&id=06db2290&scoped=true"
import script from "./YearCalendar.vue?vue&type=script&lang=js"
export * from "./YearCalendar.vue?vue&type=script&lang=js"
import style0 from "./YearCalendar.vue?vue&type=style&index=0&id=06db2290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06db2290",
  null
  
)

export default component.exports